import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsCreate } from 'services/WService';

const TEMPLATE_FIELDS = ['FechaEmisión', 'TipoDoc', 'Serie', 'NumDoc', 'DocIdentidad', 'Total'];

// Modal de import: sube el Excel del SIRE y lo guarda (parseo + guardado server-side).
export default function SireModal(props) {
  const { open, onClose, entity, title, showNotify, reload } = props;
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!file) {
      showNotify('Seleccioná un archivo Excel', 'warning');
      return;
    }
    const formData = new FormData();
    formData.append('import', file);

    setSaving(true);
    const res = await wsCreate(entity, formData);
    setSaving(false);

    if (res.success) {
      showNotify(res.message || 'Registros guardados', 'success');
      setFile(null);
      onClose();
      reload();
    } else {
      showNotify(res.message || 'Error al guardar', 'error');
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <p style={{ fontSize: 13, color: '#666' }}>
          Columnas del Excel (orden indistinto): <b>{TEMPLATE_FIELDS.join(', ')}</b>.
        </p>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ImportExcel
            onChange={(e) => setFile(e.target.files[0])}
            validDuplicate="NumDoc"
            btnColor="success"
            btnLabel="Importar Excel"
            downTemplate={{ fileNameDown: 'Plantilla SIRE', fields: TEMPLATE_FIELDS }}
          />
        </div>
        {file && (
          <p style={{ color: '#07c107', marginTop: 12, fontSize: 14 }}>Archivo: {file.name}</p>
        )}
      </DialogContent>
      <DialogActions style={{ padding: '10px 20px' }}>
        <RegularButton color="success" disabled={saving || !file} onClick={save}>
          {saving ? 'Guardando...' : 'Guardar'}
        </RegularButton>
        <RegularButton color="danger" disabled={saving} onClick={onClose}>
          Cerrar
        </RegularButton>
      </DialogActions>
    </Dialog>
  );
}
